import { useEffect } from 'react';
import { useSelector } from 'react-redux';

function StockController({active, onFailure}) {
    const tickets = useSelector(
        state => state.tickets.confirmed_tickets != null
            ? state.tickets.confirmed_tickets.map(t => t.id)
            : [],
    );

    const hotels = useSelector(
        state => state.hotels.confirmed_hotel_range != null
            ? state.hotels.confirmed_hotel_range.variations.map(h => h.id)
            : [],
    );

    const roomType = useSelector(state => state.hotels.selected_hotel_roomtype);

    useEffect(() => {
        return;

        const interval = setInterval(async () => {
            if (!active || (tickets.length === 0 && hotels.length === 0)) {
                return;
            }

            const data = new FormData();
            for (let i = 0, l = tickets.length; i < l; ++i) {
                data.append('tickets', tickets[i]);
            }

            for (let i = 0, l = hotels.length; i < l; ++i) {
                data.append('hotels', hotels[i]);
            }

            const onSuccessResponse = response => {
                if (!response || !response.data) {
                    return;
                }

                if (!response.data.in_stock) {
                    onFailure(
                        response.data.type === 'tickets',
                        response.data.type === 'hotels',
                    );
                }
            };

            let response;
            try {
                const request = await fetch(
                    '/wp-json/nojesresor/v1/checkout/stock',
                    {
                        method: 'POST',
                        body: data,
                    },
                );

                response = await request.json();

                if (request.status !== 200) {
                    throw new Error(response.code);
                }
            } catch (ex) {
                console.error(ex);
                return;
            }

            onSuccessResponse(response);
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, [tickets, hotels, roomType]);

    return null;
}

export default StockController;
